import script from "./OutreachDraftSentView.vue?vue&type=script&setup=true&lang=js"
export * from "./OutreachDraftSentView.vue?vue&type=script&setup=true&lang=js"

import "./OutreachDraftSentView.vue?vue&type=style&index=0&id=7db151b2&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7db151b2"]])

export default __exports__